<template>
    <div class="page cartPage">
        <div class="d-flex flex-column min-h-100 flexWrapBox">
            <div class="container mediaHideOnDesctop">
                <div class="row">
                    <div class="col-12">
                        <router-link class="addToCardMore" :to="{name: 'Menu'}">
                            <img :src="getStaticImage('icons/card/addMore.png')">
                            <span>Add More Items</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="pickupinfoBox">
                <div class="container">
                    <div class="row">
                        <div class="col-12 pickupinfo">
                            <div class="h2 descktopMediaBox">Pickup from</div>
                            <div class="fromBox">
                                <div class="title">
                                    <img :src="getStaticImage('icons/checkout/pickup_logo_cart.svg')" style="transform: translateX(-2px);margin-right: -4px">
                                    <span>From:</span>
                                </div>
                                <router-link class="edit" :to="{name: 'Locations'}">
                                    <img :src="getStaticImage('icons/card/edit.png')">
                                </router-link>
                                <div class="address caption">
                                    {{ cart.business.fullAddress() }}
                                </div>
                            </div>
                            <div class="timeBox">
                                <div class="title">
                                    <img :src="getStaticImage('icons/card/time.png')">
                                    <span>Time:</span>
                                </div>
                                <router-link class="edit" :to="{name: 'Locations', query: {datetime:1}}">
                                    <img :src="getStaticImage('icons/card/edit.png')">
                                </router-link>
                                <div class="time caption">
                                    {{ cart.calcOrderTime() }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="descktopMediaBox left">
                    
                    <div class="container specmessage">
                        <div class="row">
                            <div class="col-12">
                                <form class="messageForm">
                                    <h4>Special Instructions</h4>
                                    <textarea name="message" v-model="cart.comment"></textarea>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="subtotalSection">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="subtotal">
                                        <div class="title h4">
                                            Subtotal:
                                        </div>
                                        <div class="price">
                                            ${{ cart.subTotal() }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="checkOutBtn mt-auto">
                        <div class="container">
                            <router-link class="btnlink inv descktopMediaBox" :to="{name: 'Menu'}">
                                <span>view menu</span>
                            </router-link>
                            <a @click="checkout()" class="btnlink zbg">checkout</a>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="container orderListBox">
                <div class="row">
                    <div class="col-12">
                        <h3 class="ktdarkchoc rob">Your Order</h3>
                        <div class="cardList">
                            <div class="itemMenu" v-for="(prod,index) in cart.products">
                                <div  class="imgBox descktopMediaBox" :style="{backgroundImage: 'url(\''+prod.photo_large+'\')'}"></div>
                                <div class="titleBOx">
                                    <div class="name h5 ktdarkchoc">
                                        {{ prod.menu_title }}
                                        <div class="caption">
                                        <span v-for="(m,index,key) in prod.activeModifiers"><span v-if="m.quantity>1">x{{m.quantity}}</span>
                                            {{m.title.toLowerCase()}}<span v-if="key != Object.keys(prod.activeModifiers).length -1">, </span></span>
                                        </div>
                                    </div>
                                    <div class="edit h5 mediaHideOnDesctop" @click="$router.push({name: 'SingleMenuItem', params: {id: prod.menu_id}, query: {cartItem: index}})">
                                        Edit
                                    </div>
                                </div>
                                <div class="botActions">
                                    <div class="quantBox">
                                        <span v-if="prod.category_id!=18005" @click="prod.changeQuantity(-1)"><svg width="24" height="4" viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                                            d="M0.333374 2H23.6667" stroke="#B72D24" stroke-width="4"></path></svg></span>
                                        <div v-if="prod.category_id!=18005" class="qty">{{ prod.quantity }}</div>
                                        <span v-if="prod.category_id!=18005" @click="prod.changeQuantity(+1)"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                                            d="M23.6666 13.6667H13.6666V23.6667H10.3333V13.6667H0.333252V10.3333H10.3333V0.333328H13.6666V10.3333H23.6666V13.6667Z"
                                            fill="#B72D24"></path></svg></span>
                                    </div>
                                    <div class="priceRmove">
                                        <div class="price h2">
                                            ${{ prod.totalPrice() }}
                                        </div>
                                        <div class="remove h5 mediaHideOnDesctop" @click="$store.commit('cart/removeFromCart',index)">
                                            Remove
                                        </div>
                                    </div>
                                </div>
                                <div class="desctopActions descktopMediaBox">
                                    <div class="edit h5" @click="$router.push({name: 'SingleMenuItem', params: {id: prod.menu_id}, query: {cartItem: index}})">
                                        Edit
                                    </div>
                                    <div class="remove h5" @click="$store.commit('cart/removeFromCart',index)">
                                        Remove
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="subtotalSection mediaHideOnDesctop">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="subtotal">
                                <div class="title h4">
                                    Subtotal:
                                </div>
                                <div class="price">
                                    ${{ cart.subTotal() }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container specmessage mediaHideOnDesctop">
                <div class="row">
                    <div class="col-12">
                        <form class="messageForm">
                            <h4>Special Instructions</h4>
                            <textarea name="message" v-model="cart.comment"></textarea>
                        </form>
                    </div>
                </div>
            </div>
            <div class="checkOutBtn mt-auto mediaHideOnDesctop" v-if="parseInt(cart.business.order_ability) === 1 && parseInt(cart.business.takeout) === 1">
                <div class="container">
                    <router-link class="btnlink inv descktopMediaBox" :to="{name: 'Menu'}">
                        <span>view menu</span>
                    </router-link>
                    <a @click="checkout()" class="btnlink zbg">checkout</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Cart",
        created() {
            //time corection
            this.$store.commit("shared/setTopBar", {
                title: this.cart.business.fullAddress() + "<br/>PickUp " + this.cart.calcOrderTime(),
                showBackButton: true,
                showX: true,
                showBag: true,
                smallText: true
            });
        },
        methods: {
            checkout() {
                this.$router.push({name: "Checkout"});
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart
            }
        }

    }
</script>

